export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70a4a43b503aff093255ae813242143a472d6fdbc2&name=pushAdClickData!'